module.exports = __webpack_public_path__ + "img/ico-loglar.0da08811.svg";